export default __webpack_public_path__ + "static/guildquality-0324b85d7348fb568b7a9c860f861ec7.svg";